export const GROUP_RECONFIG_MODAL_LOCAL_STORAGE_KEY =
  'dont-show-group-reconfig-modal';

export function getDontShowGroupReconfigModal() {
  const ls = localStorage.getItem(GROUP_RECONFIG_MODAL_LOCAL_STORAGE_KEY);
  return ls ? JSON.parse(ls) : [];
}

export function addGroupToDontShowGroupReconfigModal(id: number) {
  const ls = getDontShowGroupReconfigModal();
  localStorage.setItem(
    GROUP_RECONFIG_MODAL_LOCAL_STORAGE_KEY,
    JSON.stringify([...ls, id]),
  );
}
